import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SvgTramIcon() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11.983"
        height="16.583"
        viewBox="0 0 11.983 16.583"
      >
        <path
          id="tram"
          d="M70.614,9.408l-.571-5.443A2.476,2.476,0,0,0,67.58,1.747H66.154v-.7h.536a.387.387,0,0,1,.318.168A.523.523,0,0,0,67.87.62,1.434,1.434,0,0,0,66.69,0H62.583A1.434,1.434,0,0,0,61.4.62a.523.523,0,1,0,.862.594.387.387,0,0,1,.319-.168h.536v.7H61.693A2.477,2.477,0,0,0,59.23,3.966l-.571,5.453a2.478,2.478,0,0,0,.07.9l.572,2.142a2.477,2.477,0,0,0,1.744,1.751l-.589,1.679a.523.523,0,1,0,.988.346l.679-1.938H67.15l.68,1.938a.523.523,0,0,0,.988-.346l-.589-1.679a2.477,2.477,0,0,0,1.745-1.754l.571-2.151A2.473,2.473,0,0,0,70.614,9.408ZM64.165,1.047h.942v.7h-.942v-.7Zm-1.13,11.061a.23.23,0,0,1-.23.23H61.16a.23.23,0,0,1-.226-.185l-.184-.928a.23.23,0,0,1,.226-.275H62.8a.23.23,0,0,1,.23.23v.928Zm5.488-.883-.184.928a.23.23,0,0,1-.226.185H66.468a.23.23,0,0,1-.23-.23V11.18a.23.23,0,0,1,.23-.23H68.3a.23.23,0,0,1,.226.275Zm-8.24-2.565.339-3.237a1.839,1.839,0,0,1,1.829-1.647h4.371A1.839,1.839,0,0,1,68.65,5.421l.34,3.238H60.282Z"
          transform="translate(-58.645)"
          fill="#5c5c5c"
        />
      </svg>
    </SvgIcon>
  );
}
